module.exports = __webpack_public_path__ + "img/keyboard-arrow-up.0b10c02d.svg";